// Welcome video configuration - easy to swap
export const WELCOME_VIDEO_ID = process.env.NEXT_PUBLIC_WELCOME_VIDEO_ID || 'JBbuxqn2np0';
export const WELCOME_VIDEO_URL = `https://www.youtube.com/embed/${WELCOME_VIDEO_ID}`;
